<template>
    <div class="real-top-bar-container">
        <div class="real-top-bar-logo">
            <img v-if="context.logoContentUnit"  :src="context.storageEndpoint + context.logoContentUnit.file_name" @click="goToLanding"/>
        </div>
        <div class="top-bar-right-items">
            <template v-if="hasLogInEnabled">
                <div v-if="!customer" cy-button="login" class="top-bar-button" @click="openLoginBox()">{{$t('general.login')}}</div>
                <div v-else ref="customerMenuButton">
                    <div class="customer-avatar-container" @click="openCustomerMenu" >
                        <img v-if="customer.final_avatar_path" class="avatar-icon" :src="customer.final_avatar_path" width=40 height=40/>
                        <img v-else width="30" src="/images/icon-customer-no-avatar.png" />
                        <div>{{ customer.name }}</div>
                    </div>
                    <floating-window
                        v-if="customerMenuAnchorEle"
                        align="right"
                        :anchor-ele="customerMenuAnchorEle"
                        :scroll-element-class="scrollElementClass"
                        v-on-clickaway="closeCustomerMenu"
                        :style="{zIndex: 1000}">
                        <ul class="action-menu">
                            <li class="no-text-selectable" style="padding: 5px 12px;">{{customer.name}}</li>
                            <li class="action-menu-item no-text-selectable" @click="openCustomerProfile">
                                <i class="action-menu-item-icon icon-customer-profile"></i>
                                {{$t('general.profile')}}
                            </li>
                            <li class="action-menu-item no-text-selectable" @click="openCustomerBooking">
                                <i class="action-menu-item-icon icon-customer-booking"></i>
                                {{$t('general.bookings')}}
                            </li>
                            <li class="action-menu-item no-text-selectable" @click="logout">
                                <i class="action-menu-item-icon icon-customer-logout"></i>
                                {{$t('general.logout')}}
                            </li>
                        </ul>
                    </floating-window>
                </div>
            </template>
            <div v-if="!customer" class="top-bar-button ml-2" @click="showTrackOrderBox = true">{{$t('general.track_order')}}</div>
            <currency-select class="ml-2" />
            <track-order-box
                v-if="showTrackOrderBox"
                :context="context"
                :provider="provider"
                @close="showTrackOrderBox = false" />

            <login-box
                v-if="showLoginBox"
                :logoContentUnit="context.logoContentUnit" :context="context" :provider="provider"
                :login-hint="loginHint"
                @close="closeLoginBox"
                @logged-in="onLoggedIn" />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import floatingWindow from '../common/FloatingWindow.vue';
import loginBox from '../LoginBox.vue';
import { directive as onClickaway } from 'vue-clickaway';
import TrackOrderBox from '../TrackOrderBox.vue';
import promptConfirm from '../../mixins/prompt-confirm';
import Cookies from 'js-cookie';
import CurrencySelect from './CurrencySelect.vue';

export default {
    components: { floatingWindow, loginBox, TrackOrderBox, CurrencySelect },
    directives: { onClickaway },
    mixins: [promptConfirm],
    props: ['provider', 'context', 'scrollElementClass'],
    computed: {
        ...mapGetters({
            customer: 'app/customer',
            showLoginBox: 'app/showLoginBox',
            loginHint: 'app/loginHint',
        }),
        hasLogInEnabled() {
            return !!(this.provider.login_setting && this.provider.login_setting.enabled);
        },
    },
    data() {
        return {
            showTrackOrderBox: false,
            customerMenuAnchorEle: null,
        }
    },
    async mounted() {
        if (Cookies.get('line_login_result')) {
            this.openLoginBox();
        }
    },
    methods: {
        ...mapActions({
            getLoggedInCustomer: 'app/getLoggedInCustomer',
            logOutCustomer: 'app/logOutCustomer',
            openLoginBox: 'app/openLoginBox',
            closeLoginBox: 'app/closeLoginBox',
        }),
        onLoggedIn(scrollToCart) {
            this.closeLoginBox();
            this.promptAlert(
                this.$t('message.you_have_logged_in_welcome'),
                scrollToCart ? this.scrollToPaymentSection : null,
                'success'
            );
        },
        scrollToPaymentSection() {
            this.$nextTick(() => {
                const loginWithBooking = Cookies.get('login_with_booking');
                const target = document.getElementById('cart-section');
				if (loginWithBooking && target) {
                    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    Cookies.remove('login_with_booking', { path: '/' });
				}
			});
		},
        async logout() {
            await this.logOutCustomer();
            window.document.location = '/';
        },
        openCustomerProfile() {
            window.document.location = '/me'
        },
        openCustomerBooking() {
            window.document.location = '/me?bookings'
        },
        openCustomerMenu() {
            this.customerMenuAnchorEle = this.$refs['customerMenuButton'];
        },
        closeCustomerMenu() {
            this.customerMenuAnchorEle = null;
        },
        goToLanding() {
            window.document.location = '/';
        }
    }
}
</script>

<style scoped lang="scss">

.real-top-bar-container {
    display: flex;
    justify-content: space-between;
}

.top-bar-button {
    color: #666;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    user-select: none;
    padding: 8px 16px;

    &:hover {
        color: #111;
        background: #f0f0f0;
        border-radius: 12px;
    }

    @media screen and (max-width: 425px) {
        & {
            font-size: 12px;
            padding: 4px 8px;
        }

    }
}

.top-bar-right-items {
    display: flex;
    align-items: center;
    justify-content: right;
}

.customer-avatar-container {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;

    .avatar-icon {
        border-radius: 20px;
    }

    &:hover .avatar-icon {
        border: 2px solid #333;
    }
}

.action-menu-item-icon.icon-customer-profile {
    background-image: url('/img/icon_customer_info.png');
}

.action-menu-item-icon.icon-customer-booking {
    background-image: url('/img/icon_customer_bookings.png');
}

.action-menu-item-icon.icon-customer-logout {
    background-image: url('/img/icon-customer-logout.png');
}

.action-menu {
    background: white;
    border-radius: 4px;
    box-shadow: 0px 0px 4px 3px rgba(0,0,0,0.13);
    text-align: center;
    padding-left: 0;
    list-style: none;
    z-index: 80;
}

.action-menu-item {
    padding: 8px 16px;
    color: #707070;
    font-size: 14px;
    text-align: left;
}

.action-menu-item:hover {
    background: #EEE;
    cursor: pointer;
}

.action-menu-item-icon {
    display: inline-block;
    position: relative;
    top: 4px;
    margin-right: 12px;
    width: 18px;
    height: 18px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.real-top-bar-logo  img {
    height: 44px;
}
</style>